import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../cms/block/abstract-cms-block.component';

export interface ICheckoutSuccessContentBlock extends NICmsContentComponent.IData {
    heading?: string;
    copy?: string;
}

@Component({
    selector: 'checkout-success-content-block',
    templateUrl: './checkout-success-content-block.component.html',
    styleUrl: './checkout-success-content-block.component.scss',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CheckoutSuccessContentBlockComponent>({
    id: 'checkout-success-content-block',
    block: {
        url: 'checkout-success-content-block'
    },
    onDemandOnly: true,
    name: 'Checkout Success Content Block',
    description: 'Content block used on checkout succes page',
    fields: [
        <NICmsContentField.IField>{
            key: 'heading',
            type: NICmsContentField.EFieldType.text,
            title: 'Heading'
        },
        <NICmsContentField.IField>{
            key: 'copy',
            type: NICmsContentField.EFieldType.text,
            title: 'Copy'
        }
    ]
})
export class CheckoutSuccessContentBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: ICheckoutSuccessContentBlock;
}
